import { RootState } from 'src/config/rootStore';

import { config } from 'src/config/config';

import { ContentLanguages } from '../rematchModels/contentLanguages';
import {
    getI18nLanguageFromLocalStorage,
    getI18nLanguageByLanguageName,
} from 'src/shared/helpers/getPreferredLanguage';
import {
    contentLanguageCodeToi18nLanguage,
    languageNameToContentLanguages,
} from 'src/config/i18n.config';

const getContentLanguages = (state: RootState) =>
    (state.contentLanguages || {}) as ContentLanguages;

export const getContentLanguagesLoaded = (state: RootState) => state.contentLanguages !== null;

export const getAvailableContentLanguages = (rootState: RootState) => {
    return getContentLanguages(rootState);
};

export const getPreferredI18nLanguageFromLocalStoreOrGuessFromBrowser = (rootState: RootState) => {
    let browserLanguage = getI18nLanguageFromLocalStorage() || getBrowserLanguage();
    if (browserLanguage === 'zh-CN') {
        browserLanguage = 'zh-Hans';
    }

    const languageWithCountry = ['en-US', 'fr-CA', 'zh-Hans'];

    //for other languages we need to remove country part in string
    if (!languageWithCountry.includes(browserLanguage)) {
        browserLanguage = browserLanguage.includes('-')
            ? browserLanguage.split('-')[0]
            : browserLanguage;
    }
    const contentLanguage = getContentLanguageFromI18nLanguage(browserLanguage);
    if (!contentLanguage) return config.defaultLanguage;

    return isContentLanguageAvailable(rootState, contentLanguage)
        ? browserLanguage
        : config.defaultLanguage;
};

export const isContentLanguageAvailable = (rootState: RootState, language?: string) => {
    if (!language) return false;

    const availableContentLanguages = Object.values(getAvailableContentLanguages(rootState));
    return availableContentLanguages.includes(language);
};

const getBrowserLanguage = () => navigator.language;

export const getAvailableI18nLanguagefromLanguageName = (
    rootState: RootState,
    languageName?: string,
) => {
    if (!languageName) return config.defaultLanguage;

    const contentLanguageName = getContentLanguageFromLanguageName(languageName);

    if (!contentLanguageName) return config.defaultLanguage;

    return isContentLanguageAvailable(rootState, contentLanguageName)
        ? getI18nLanguageByLanguageName(languageName) || config.defaultLanguage
        : config.defaultLanguage;
};

export const getContentLanguageFromLanguageName = (languageName?: string): string | undefined => {
    return languageName && languageNameToContentLanguages[languageName];
};

export const getContentLanguageFromI18nLanguage = (i18nLanguage: string): string | undefined => {
    return Object.entries(contentLanguageCodeToi18nLanguage).find(
        ([, value]) => value === i18nLanguage,
    )?.[0];
};
